export const CREATE_DIAGNOSIS = 'diagnoses/CREATE_DIAGNOSIS';
export const EDIT_DIAGNOSIS = 'diagnoses/EDIT_DIAGNOSIS';
export const SHARE_DIAGNOSIS = 'diagnoses/SHARE_DIAGNOSIS';
export const UNSHARE_DIAGNOSIS = 'diagnoses/UNSHARE_DIAGNOSIS';
export const FETCH_ENCOUNTER_DIAGNOSES = 'diagnoses/FETCH_ENCOUNTER_DIAGNOSES';
export const FETCH_DIAGNOSES_FOR_DROPDOWN = 'diagnoses/FETCH_FOR_DROPDOWN';
export const DELETE_DIAGNOSIS = 'diagnoses/DELETE_DIAGNOSIS';

export function fetchEncounterDiagnoses(encounterId, {offset, limit}) {
    return {
        type: FETCH_ENCOUNTER_DIAGNOSES,
        httpRequest: {
            method: 'post',
            path: `/diagnoses/list/${encounterId}`,
            data: {
                offset,
                limit,
            },
        },
        offset,
        limit,
    };
}

export function createDiagnosis(encounterId, patientId, fields) {
    return {
        type: CREATE_DIAGNOSIS,
        httpRequest: {
            method: 'post',
            path: `/diagnoses/create/${encounterId}`,
            data: {
                ...fields,
                patientId,
            },
        },
    };
}

export function editDiagnosis(diagnosisId, fields) {
    return {
        type: EDIT_DIAGNOSIS,
        httpRequest: {
            method: 'put',
            path: `/diagnoses/edit/${diagnosisId}`,
            data: {
                ...fields,
            },
        },
        id: diagnosisId,
        fields,
    };
}

export function shareDiagnosis(diagnosisId) {
    return {
        type: SHARE_DIAGNOSIS,
        httpRequest: {
            method: 'put',
            path: `/diagnoses/share/${diagnosisId}`,
        },
        diagnosisId,
    };
}

export function unshareDiagnosis(diagnosisId) {
    return {
        type: UNSHARE_DIAGNOSIS,
        httpRequest: {
            method: 'put',
            path: `/diagnoses/unshare/${diagnosisId}`,
        },
        diagnosisId,
    };
}

export function fetchDiagnosesForDropdown(search) {
    return {
        type: FETCH_DIAGNOSES_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/diagnoses/list/dropdown',
            params: {
                search,
            },
        },
    };
}

export function deleteDiagnosis(diagnosisId) {
    return {
        type: DELETE_DIAGNOSIS,
        httpRequest: {
            method: 'del',
            path: `/diagnoses/delete/${diagnosisId}`,
        },
        id: diagnosisId,
    };
}



// WEBPACK FOOTER //
// ./src/reducers/diagnoses/diagnosesActions.js